import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { connect } from "react-redux";
import MainWrapper from "../wrappers/MainWrapper";
import { Link } from "react-router-dom";
import CustomTextField from "../../components/fields/CustomTextField";
import CheckboxGroup from "../../components/fields/CheckboxGroup";
import { reduxForm, Field, reset } from "redux-form";
import validateEmail from "../../utils/validateEmail";
import {   checkUserRole} from "../../actions";
import NotificationSnackBar from '../../utils/NotificationSnackBar';
import Navlink from "../../components/wrappers/Navlink";


import CircularProgress from '@material-ui/core/CircularProgress';
import Modal from '@material-ui/core/Modal';
import Snackbar from '@material-ui/core/Snackbar';
import PlusCircleIcon from '@material-ui/icons/AddCircle';
import TextField from '@material-ui/core/TextField'; 
import SearchIcon from '@material-ui/icons/Search';
import Grid from '@material-ui/core/Grid';
import List from '@material-ui/core/List';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemIcon from '@material-ui/core/ListItemIcon'; 
import Button from '@material-ui/core/Button';
import Divider from '@material-ui/core/Divider';
import { withStyles,makeStyles  } from '@material-ui/core/styles';
import TablePagination from '@material-ui/core/TablePagination';
import Checkbox from '@material-ui/core/Checkbox';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';



import EnhancedTableToolbar from '../../utils/EnhancedTableToolbar';
import UserTable from '../../utils/MainTable/UserTable';
import { userListStyle } from '../../utils/Style';
import CompanyListTable from '../../utils/MainTable/CompanyListTable';
import { MAPCLIENT_URL_DOMAIN } from "../../utils/constants";

function getModalStyle() {
    return {
        top: `${50}%`,
        left: `${50}%`,
        transform: `translate(-${50}%, -${50}%)`,
    };
}


const useStyles = theme => ({
    root: {
      margin: 'auto',
    },
    cardHeader: {
      padding: theme.spacing(1, 2),
    },
    list: {
      width: 200,
      height: 230,
      backgroundColor: theme.palette.background.paper,
      overflow: 'auto',
    },
    button: {
      margin: theme.spacing(0.5, 0),
    },
    loadingHeight: {
        height: "100%",
        position: "fixed",
        top: "0",
        right: "0"
    },
    container: {
        display: "flex",
        flexWrap: "wrap",
        width: 350
    },
    button: {
        width: 300,
        marginLeft: "auto",
        marginRight: "auto",
        marginTop: 10
    },
    alreadySignIn: {
        marginTop: 10,
        marginBottom: 10,
        marginLeft: "auto",
        marginRight: "auto"
    },
    success: {
        marginTop: 10,
        marginBottom: 10,
        marginLeft: "auto",
        marginRight: "auto",
        color: "green"
    }
  });

const required_fields = [
    { name: "description", label: "description" },
    { name: "expiryDay", label: "expiry day" },
    { name: "type", label: "type" },
];

const WAIT_INTERVAL = 1000;

const styles = theme => ({
    root: {
        flexGrow: 1,
    },
    loadingHeight: {
        height: "100%",
        position: "fixed",
        top: "0",
        right: "0"
    },
    container: {
        display: "flex",
        flexWrap: "wrap",
        width: 350
    },
    button: {
        width: 300,
        marginLeft: "auto",
        marginRight: "auto",
        marginTop: 10
    },
    alreadySignIn: {
        marginTop: 10,
        marginBottom: 10,
        marginLeft: "auto",
        marginRight: "auto"
    },
    success: {
        marginTop: 10,
        marginBottom: 10,
        marginLeft: "auto",
        marginRight: "auto",
        color: "green"
    }
});
 
class ConfigureMap extends React.Component {
    
    constructor(props, context) {
        super(props, context);
        this.state = {
            selected: [],
            open: false,
            isSwitchSnackbarOn: false,
            phone:'',
            fax:'',
            newCompName:'',
            regNo:'',
            mailadd:'',
            page: 0,
            rowsPerPage: 5,
            offset: 0, 
            retrieveCompstatus:[], 
            dateFrom:'',
            dateTo:'',
            retrieveComp:null,
            loading:false,
            contextChanged:true,
            checked:[], 
            left:['Peat', 'Non RSPO','Protected','Triggered Modis','Triggered VIIRS','Attended reports'], 
            right:['OSM','Mapbox','Concession'],  
            userRoles:{
                userRoles:[],
                error:null
            },
            leftChecked:[],
            rightChecked:[],
        }; 
     //   this.state.leftChecked = this.intersection(this.state.checked, this.state.left);
     //   this.state.rightChecked = this.intersection(this.state.checked, this.state.right);
    }
    intersection=(a, b) =>{
        return a.filter(value => b.indexOf(value) !== -1);
      }
      union=(a, b)=> { 
        return [...a, ...this.not(b, a)];
      }
      not=(a, b) =>{
        return a.filter(value => b.indexOf(value) === -1);
      }
    numberOfChecked = items  =>{return this.intersection(this.state.checked, items).length};
    handleToggle = value => () => {
        const currentIndex = this.state.checked.indexOf(value);
        const newChecked =  [...this.state.checked];
        var l = this.state.left;
        var r = this.state.right;
        if (currentIndex === -1) {
          newChecked.push(value);
        } else {
          newChecked.splice(currentIndex, 1);
        }
        this.setState({checked: newChecked, 
        });
      };
     

      handleToggleAll = items => () => {
        var c = this.state.checked;
        var l = this.state.left;
        var r = this.state.right;
        if (this.numberOfChecked(items) === items.length) {
       
          var a = this.not(c, items); 
          this.setState({checked: a, 
          }); 
        } else {
            var a = this.union(c, items); 
            console.log(a)
            this.setState({checked: a, 
            }); 
        }
      };

      handleCheckedRight = () => {
        var l = this.state.left;
        var r = this.state.right;
        var c = this.state.checked;

         
        var z=this.not(l, this.intersection(c, l) );
        var z2 = this.not(c,  this.intersection(c, l));
        var z1 =r.concat( this.intersection(c, l)); 
        this.setState({ 
            right:z1,   
            left:z,
            checked: z2, 
        });
      };
  
      
      handleCheckedLeft = () => {
        var l = this.state.left;
        var r = this.state.right;
        var c = this.state.checked;
        
        var z=this.not(r,  this.intersection(c, r));
        var z2 = this.not(c,   this.intersection(c, r));
        var z1 =l.concat(  this.intersection(c, r));
        console.log(z1)
        this.setState({  
            left:z1,
            right:z,
            checked:z2, 
        });
      };



    componentDidMount(){
        var today = new Date();
        var dd = String(today.getDate()).padStart(2, '0');
        var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
        var yyyy = today.getFullYear();

        today =yyyy + '-' +mm + '-' + dd ;
            //    this.props.checkfilestatus(today,today );
        this.setState({ loading: false,
            dateFrom: today,
            dateTo:today,
        });
    } 

    static getDerivedStateFromProps(props, state) {
        let update = {}; 
        
        update.loading = false;
        if(props.userRoles.success !== null)
        if(!props.userRoles.success){ 
            localStorage.clear(); 
            props.history.push("/signIn"); 
        }
        if(props.userRoles.userRoles.length !== state.userRoles.userRoles.length){ 
            if(props.userRoles.userRoles.length === 0){ 
            localStorage.clear(); 
            props.history.push("/signIn"); 
            }
        }


        return update;
    } 

    handleChange=(name)=>(event )=>{
        this.updateSnackbarStatusFalse();
        this.setState({[name]: event.target.value});
    }
   
    updateSnackbarStatus = (snackbarObject) => {
        this.setState({
            isSnackbarError: snackbarObject.isSnackbarError,
            isSwitchSnackbarOn: snackbarObject.isSwitchSnackbarOn,
            snackbarErrorMessage: snackbarObject.ErrorMessage
        })
    }

    updateSnackbarStatusFalse = () => {
        if (this.state.isSwitchSnackbarOn) {
            this.setState({ isSwitchSnackbarOn: false })
        }
    }
      

    showMap =()=>{
         
        this.updateSnackbarStatusFalse(); 

       
    }

    
  customList = (title, items,classes ) =>  
     ( <Card>
        <CardHeader
          className={classes.cardHeader}
          avatar={
            <Checkbox
              onClick={this.handleToggleAll(items)}
              checked={this.numberOfChecked(items) === items.length && items.length !== 0}
              indeterminate={this.numberOfChecked(items) !== items.length && this.numberOfChecked(items) !== 0}
              disabled={items.length === 0}
              inputProps={{ 'aria-label': 'all items selected' }}
            />
          }
          title={title}
          subheader={`${this.numberOfChecked(items)}/${items.length} selected`}
        />
        <Divider />
        <List className={classes.list} dense component="div" role="list">
                 
       { items.map(value => {
          const labelId = `transfer-list-all-item-${value}-label`;
                
          
    return ( 
            <ListItem key={value} role="listitem" button onClick={this.handleToggle(value)}>
              <ListItemIcon>
                <Checkbox
                  checked={  this.state.checked.indexOf(value) !== -1}
                  tabIndex={-1}
                  disableRipple
                  inputProps={{ 'aria-labelledby': labelId }}
                />
              </ListItemIcon>
              <ListItemText id={labelId} primary={`${value  }`} />
            </ListItem>
         );
        })}
       
        <ListItem />
          </List>
        </Card>
     
  );

  
  handleDate = (name)  => event =>{
        let that = this;
        let e =event;
        console.log( this.state[name])
        if(e.target.value !== this.state[name]){
        that.setState({[name]: e.target.value,
            contextChanged:true});
        } 
    }


    render() { 

        const classes = this.props;
        const { right,left,leftChecked, rightChecked,checked
        
        } = this.state;
      
        return (
            <MainWrapper
            history={this.props.history}
                isDisplayOn="none"
                userRoles={this.props.userRoles}>
          <Paper style={{marginTop:'10px',marginBottom:'10px'}}>
                <Grid container style={{padding:'10px'}}>
                <Grid container  >
                        <Grid item>
                        <EnhancedTableToolbar
                        tableName='Configure Map' numSelected={0}
                    />
                        </Grid>
                        
                        <Grid item>
                            
                        </Grid>
                    </Grid>
                    <Grid container spacing={8} alignItems="flex-end">
                            <Grid item>
                                <SearchIcon />
                            </Grid>
                            <Grid item>
                            <TextField
                                id="dateFrom"
                                label="Date From"
                                type="date"
                                defaultValue={this.state.dateFrom}
                                InputLabelProps={{
                                shrink: true,
                                }} 
                                onChange={this.handleDate('dateFrom')}
                            />
                            </Grid>
                            <Grid item>
                            <TextField
                                id="dateTo"
                                label="Date To"
                                type="date"
                                defaultValue={this.state.dateTo} 
                                InputLabelProps={{
                                shrink: true,
                                }}
                                onChange={ this.handleDate('dateTo')}
                            />
                            </Grid>
                            <Grid item> 
                            </Grid>
                            
                        </Grid>
                        </Grid>
                        </Paper>
                        
          <Paper style={{marginTop:'10px',marginBottom:'10px'}}>
          <Grid container style={{padding:'10px'}}>
                    <Grid container  style={{marginLeft:'50px'}}>
                        <Grid container spacing={2}   className={classes.root}>
                            <Grid item>
                            
             {this.customList('Available Layers',  left,classes)}
                          </Grid>
                            <Grid item>
                                <Grid container direction="column" alignItems="center">
                                <Button
                                    variant="outlined"
                                    size="small"
                                    className={classes.button}
                                    onClick={this.handleCheckedRight}
                                    disabled={this.intersection(checked, left) .length === 0}
                                    aria-label="move selected right"
                                >
                                    &gt;
                                </Button>
                                <Button
                                    variant="outlined"
                                    size="small"
                                    className={classes.button}
                                    onClick={this.handleCheckedLeft}
                                    disabled={this.intersection(checked, right) .length === 0}
                                    aria-label="move selected left"
                                >
                                    &lt;
                                </Button>
                                </Grid>
                            </Grid>
                            <Grid item> 
      {this.customList('Chosen Layers', right,classes)}
                            
                          
                          </Grid>
                        </Grid>
                    </Grid>
                     
                    <Grid container style={{marginTop:'10px',marginLeft:'50px'}}>
                        <Grid item xs={4}>
                          
                        </Grid>
                        
                        <Grid item style={{padding:'10px'}}>
                        <Button style={{ marginLeft: '10px' }}     variant="contained" color="secondary" className={classes.button}  >
                            <Navlink style={{ color: '#fff' }} color="primary" variant="contained"  to={'//' + MAPCLIENT_URL_DOMAIN+'/app/index.html?k=' + localStorage.apiKey+ '&ses='+ localStorage.sessionKey+ '&mt=1&l='+ this.state.right.join(',')+
                            '&df='+this.state.dateFrom+'&dt='+this.state.dateTo}  target='_blank'>
                                <i className="fas fa-chart-line classes.heading" />Show on Map
                            </Navlink>
                        </Button>
                         
                        </Grid>
                    </Grid>
                </Grid>
            </Paper> 
 
                {this.state.loading ? (
                <Grid container className={classes.root}>
                    <Grid item xs={12}>
                        <Grid container className={classes.loadingHeight} justify='center' alignItems='center'>
                            
                            <div className="d-flex justify-content-center">
                                <CircularProgress color="primary" size={70} thickness={7} />
                            </div>
                        </Grid>
                    </Grid>
                </Grid>
            ) : null
            }
            </MainWrapper>
        );
    }
}

ConfigureMap.propTypes = {
    classes: PropTypes.object.isRequired,
};

function validate(values) {
    const errors = {};

    
    return errors;
}

let SignInWithStyles = withStyles(useStyles)(ConfigureMap);

SignInWithStyles = reduxForm({ 
    form: "configureMapForm"
})(SignInWithStyles);


  //    getNotExpiredPackages={this.props.notexpiredpackagesResult}>

const mapStateToProps = ({  userRoles }) => { 
    return { 
        userRoles:userRoles,
    };
};

export default connect(
    mapStateToProps,
    { checkUserRole  }
    
)(SignInWithStyles);




// WEBPACK FOOTER //
// ./src/components/tabs/ConfigureMap.js